import React from 'react';
import PropTypes from 'prop-types';
import signUpIcon from '../../../../assets/images/sign-up.svg';
import './FeaturedProfileBanner.scss';

/* eslint-disable react/require-default-props */
function FeaturedProfileBanner(_ref) {
  var _ref$consultantName = _ref.consultantName,
    consultantName = _ref$consultantName === void 0 ? null : _ref$consultantName;
  return /*#__PURE__*/React.createElement("div", {
    className: "banner-container g-row"
  }, /*#__PURE__*/React.createElement("img", {
    src: signUpIcon,
    className: "banner-icon",
    alt: "feature_profile_icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "g-column"
  }, /*#__PURE__*/React.createElement("h2", null, consultantName ? "You're so close to connect consultants like ".concat(consultantName, "!") : 'Review and submit your project post'), /*#__PURE__*/React.createElement("div", null, consultantName ? /*#__PURE__*/React.createElement("div", null, "Tell us about your needs so that we can help you find the best match.") : /*#__PURE__*/React.createElement("div", null, "Next: Clora will contact you and help finalize your post."))));
}
FeaturedProfileBanner.propTypes = {
  consultantName: PropTypes.string
};
export default FeaturedProfileBanner;